import { FC } from "react";

import TableContractsList from "../../../components/table/contracts/TableContractsList";

import styles from './contractsList.module.scss'

const ContractsList: FC = () => {
    return (
        <div className={styles.projectsList}>
            <TableContractsList />
        </div>
    );
};

export default ContractsList;
